import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Link,
  useOutletContext,
  useParams,
  useNavigate,
} from "react-router-dom";
import {
  searchStocksApi,
  createWatchlist,
  getWatchlists,
  getWatchlistItems,
  getWatchlistsSearchPage,
  deleteWatchlist,
  deleteWatchlistItem,
  getParentWatchlists,
  getUserWatchlists,
  addStockToWatchlists,
  deleteStockFromWatchlists,
  deleteWatchlists,
  getUserDefaultWatchlist,
  setUserDefaultWatchlist,
  getGuideSetting,
} from "../api/user";
import GuideLauncher from "../components/guide/GuideLauncher";
import WatchlistGuideSteps from "../components/guide/WatchlistGuideSteps";
import ListSkeleton from "../components/Skeleton/ListSkeleton";
import DashboardHeader from "../components/Other/DashboardHeader";
import TopbarSearch from "../components/Sidebar/TopbarSearch";
import PageContainer from "../components/pages/PageContainer";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import SettingsPageHeading from "../components/pages/SettingsPageHeading";
import { useLocation } from "react-router-dom";
import MobileWatchlistViewer from "./MobileWatchlistPage";
import { toast } from "react-toastify";
import SearchBar from "./SearchBar";
import WatchlistDesktop from "../components/Watchlist/WatchlistDesktop";
import WatchlistMobile from "../components/Watchlist/mobile/WatchlistMobile";
import { baseSymbol, instrumentName } from "../utils/instrumentFormat";
import { IconLeftBold, IconPlusCircle } from "../icons/icons";
import pencilIcon from "../../src/images/pencil1.png";
import deleteIcon from "../../src/images/delete.png";

const SearchPage = ({ embedded = false }) => {
  const { t } = useTranslation();
  const [stocksData, setStockData] = useState([]);
  const [loader, setLoader] = useState(false);
  const { term } = useParams();
  const [category, setCategory] = useState();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [isTabView, setIsTabView] = useState(window.innerWidth < 1024);
  const [guideIcon, setGuideIcon] = useState(false);
  const [showWatchlistGuide, setShowWatchlistGuide] = useState(false);
  const watchlistDesktopRef = useRef(null);
  const watchlistMobileRef = useRef(null);
  const searchItem = localStorage.getItem("searchItem");
  const location = useLocation();
  const pathSegments2 = location.pathname.split("/");
  const isOldSearch = pathSegments2[1] === "oldsearch";

  useEffect(() => {
    const fetchGuideStatus = async () => {
      try {
        const response = await getGuideSetting();
        if (response?.data?.success && response?.data?.status === 200) {
          setGuideIcon(response?.data?.show_icon);
        } else {
          setGuideIcon(true);
        }
      } catch (error) {
        setGuideIcon(true);
      }
    };

    fetchGuideStatus();
  }, []);

  useEffect(() => {
    const sidebar = document.getElementById('sidebar');
    if (!sidebar) return;

    const checkSidebarOpen = () => {
      const isOpen = !sidebar.classList.contains('-translate-x-full');
      setIsSidebarOpen(isOpen);
    };

    checkSidebarOpen();

    const observer = new MutationObserver(checkSidebarOpen);
    observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  const fromChart1 = location.state?.fromChart ?? false;
  function getColorForId(id) {
    const colors = ["#35b23c", "#004c50", "#006565"];
    return colors[id % colors.length];
  }
  const [hasRestored, setHasRestored] = useState(false);
  const restoredRef = useRef(false);
  const [watchlists, setWatchlists] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedWatchlist, setSelectedWatchlist] = useState([]);
  const [items, setItems] = useState();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const loaderRef = useRef(null);
  const [isSystemWatchlist, setIsSystemWatchlist] = useState(false);

  const [openWatchlistId, setOpenWatchlistId] = useState(null);
  const [openWatchlistName, setOpenWatchlistName] = useState(null);

  const [initialLoading, setInitialLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const navigate = useNavigate();
  const [deleteMode, setDeleteMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedWatchlists, setSelectedWatchlists] = useState([]);
  const [deleteMode1, setDeleteMode1] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addOptions, setAddOptions] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(false);

  const [parentWatchlists, setParentWatchlists] = useState([]);
  const [selectedParentId, setSelectedParentId] = useState(null);

  const [childWatchlists, setChildWatchlists] = useState([]);
  const [selectedChildId, setSelectedChildId] = useState(null);
  const [openParentId, setOpenParentId] = useState(null);
  const [selectedParent, setSelectedParent] = useState(null);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [showAddInstrumentModal, setShowAddInstrumentModal] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteOptions, setDeleteOptions] = useState([]);
  const [selectedDeleteWatchlists, setSelectedDeleteWatchlists] = useState([]);
  const [loadingDeleteOptions, setLoadingDeleteOptions] = useState(false);

  const [userDefaultWatchlistId, setUserDefaultWatchlistId] = useState(null);
  const [isSettingDefault, setIsSettingDefault] = useState(false);
  const allowedDefaultIds = [1, 2, 3];
  const [settingWatchlistId, setSettingWatchlistId] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const fetchParentWatchlists = async () => {
    try {
      const res = await getParentWatchlists();
      const list = Array.isArray(res.data.parentWatchlists)
        ? res.data.parentWatchlists
        : [];
      setParentWatchlists(list);
    } catch (err) {
      console.error("Error fetching parent watchlists:", err);
      setParentWatchlists([]);
    }
  };

  useEffect(() => {
    fetchParentWatchlists();
  }, []);

  const handleParentClick = async (parentId) => {
    // alert(parentId);
    setSelectedParent(parentId);
    setSelectedParentId(parentId);
    setSelectedChildId(null);
    setChildWatchlists([]);
    setOpenWatchlistId(parentId);

    try {
      const res = await getWatchlistsSearchPage(parentId);
      const list = Array.isArray(res.data.watchlists)
        ? res.data.watchlists
        : [];

      setChildWatchlists(list);

      let defaultKey = null;
      if (parentId === 1) defaultKey = "stocks";
      else if (parentId === 2) defaultKey = "forex";
      else if (parentId === 3) defaultKey = "crypto";

      if (defaultKey) {
        handleWatchlistClick(defaultKey);
      }

      if (list.length > 0) {
        if (parentId === 5) {
          setIsSystemWatchlist(true);
        }

        const savedId = localStorage.getItem("uselastWatchlistId");
        let firstChild;

        if (savedId) {
          const matched = list.find((item) => item.id === Number(savedId));
          firstChild = matched || list[0];
        } else {
          firstChild = list[0];
        }

        if (firstChild) {
          handleWatchlistClick(firstChild.id);
          setOpenWatchlistName(firstChild.name);
          setDeleteMode(false);
          setSelectedItems([]);
        }

        localStorage.removeItem("uselastWatchlistId");
      }
    } catch (err) {
      console.error("Error fetching child watchlists:", err);
    }
  };

  const containerRef = useRef(null);

  const requestRef = useRef(0);

  const handleWatchlistClick = async (id, isSystem = null) => {
    const requestId = ++requestRef.current;

    setOpenWatchlistId(id);
    setOpenWatchlistName(null);
    setPage(1);
    setSelectedWatchlist([]);
    setInitialLoading(true);
    setHasMore(true);
    setLoadingMore(false);

    if (isSystem !== null) {
      setIsSystemWatchlist(isSystem);
    } else {
      const clickedWatchlist = childWatchlists.find((wl) => wl.id === id);
    }

    try {
      const res = await getWatchlistItems(id, 1, 3);

      if (requestId !== requestRef.current) return;

      if (res?.data?.items) {
        setSelectedWatchlist(res.data.items);
        setHasMore(
          res.data.pagination?.has_more ?? res.data.items.length === 3,
        );
      }
    } catch (err) {
      if (requestId === requestRef.current) {
        console.error("Error fetching watchlist items:", err);
      }
    } finally {
      if (requestId === requestRef.current) {
        setInitialLoading(false);
      }
    }
  };

  const loadMore = async () => {
    if (loadingMore || !hasMore) return;

    const requestId = requestRef.current;
    setLoadingMore(true);

    try {
      const nextPage = page + 1;
      const res = await getWatchlistItems(openWatchlistId, nextPage, 3);

      if (requestId !== requestRef.current) return;

      if (res?.data?.items?.length > 0) {
        setSelectedWatchlist((prev) => [...prev, ...res.data.items]);
        setPage(nextPage);
        setHasMore(
          res.data.pagination?.has_more ?? res.data.items.length === 3,
        );
      } else {
        setHasMore(false);
      }
    } catch (err) {
      if (requestId === requestRef.current) {
        console.error("Error loading more:", err);
      }
    } finally {
      if (requestId === requestRef.current) {
        setLoadingMore(false);
      }
    }
  };

  const fetchAllWatchlists = async () => {
    try {
      const response = await getWatchlistsSearchPage();
      const list = Array.isArray(response.data.watchlists)
        ? response.data.watchlists
        : [];

      setWatchlists(list);

      if (!isTabView && list.length > 0) {
        const savedId = localStorage.getItem("lastWatchlistId");
        const foundWatchlist = savedId
          ? list.find((wl) => wl.id === Number(savedId))
          : null;

        const target = foundWatchlist || list[0];

        setOpenWatchlistId(target.id);
        setOpenWatchlistName(target.name);

        handleWatchlistClick(target.id, target.is_system);

        if (savedId) {
          localStorage.removeItem("lastWatchlistId");
        }
      }
    } catch (err) {
      console.error("Error fetching watchlists", err);
      setWatchlists([]);
    }
  };

  const handleCreate = async () => {
    if (!name) return alert("Please enter a name");

    setLoading(true);
    try {
      await createWatchlist({ name });
      setShowModal(false);
      setName("");
      fetchParentWatchlists();
    } catch (err) {
      console.error("Error creating watchlist", err);
      alert("Failed to create watchlist");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setSelectedParent(null);
    setOpenParentId(null);
    fetchParentWatchlists();
  };

  const shouldHideForm =
    pathSegments2[1] === "buysell" ||
    pathSegments2[1] === "charts" ||
    pathSegments2[1] === "search";

  const [search, setSearch] = useState(
    term ? term : searchItem ? searchItem : "",
  );

  useEffect(() => {
    setSearch(searchItem);
  }, [searchItem]);

  const [scButton, setScButton] = useState(false);
  const searchRef = useRef("");
  const handleChange = (e) => {
    if (!shouldHideForm) {
      setSearch(e.target.value.toUpperCase());
    } else {
      const value = e;
      searchRef.current = value;
      setSearch(value);
    }
  };

  useEffect(() => {
    if (!loaderRef.current || !containerRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore) {
          loadMore();
        }
      },
      {
        root: containerRef.current,
        rootMargin: "0px",
        threshold: 0.1,
      },
    );

    observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [loaderRef, containerRef, hasMore, loadMore]);

  useEffect(() => {}, [isSystemWatchlist]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
      setIsTabView(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const clearSearch = () => {
    search.current.value = "";
    setScButton(false);
  };

  useEffect(() => {
    const lastParentId = localStorage.getItem("lastParentId");
    const lastWatchlistId = localStorage.getItem("lastWatchlistId");

    if (!lastParentId && !lastWatchlistId) return;

    restoredRef.current = true;

    const key = lastWatchlistId?.toLowerCase();
    if (["stocks", "crypto", "forex"].includes(key)) {
      handleWatchlistClick(key);
      localStorage.removeItem("lastWatchlistId");
      localStorage.removeItem("lastParentId");
      setHasRestored(true);
      return;
    }

    setHasRestored(true);

    if (lastParentId && lastParentId !== "null") {
      setSearchResults([]);
      setOpenParentId(Number(lastParentId));
      handleParentClick(Number(lastParentId));

      if (lastWatchlistId) {
        if (Number(lastParentId) === 5) {
          setIsSystemWatchlist(true);
        }

        setTimeout(() => {
          setSearchResults([]);
          handleWatchlistClick(Number(lastWatchlistId));
          setDeleteMode(false);
          setSelectedItems([]);

          localStorage.removeItem("lastParentId");
          localStorage.removeItem("lastWatchlistId");
        }, 800);
      } else {
        localStorage.removeItem("lastWatchlistId");
        localStorage.removeItem("lastParentId");
      }
    }
  }, []);

  useEffect(() => {
    if (!restoredRef.current) {
      handleWatchlistClick("stocks");
    }
  }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        setLoadingOptions(true);
        const res = await getUserWatchlists();
        if (res?.data?.watchlists) {
          setAddOptions(res.data.watchlists);
        } else {
          toast.error("No options found");
          setAddOptions([]);
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch options");
        setAddOptions([]);
      } finally {
        setLoadingOptions(false);
      }
    };

    if (showAddModal) {
      fetchOptions();
    }
  }, [showAddModal]);

  useEffect(() => {
    const fetchDeleteOptions = async () => {
      try {
        setLoadingDeleteOptions(true);
        const res = await getUserWatchlists();
        if (res?.data?.watchlists) {
          setDeleteOptions(res.data.watchlists);
        } else {
          toast.error("No watchlists found");
          setDeleteOptions([]);
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch watchlists");
        setDeleteOptions([]);
      } finally {
        setLoadingDeleteOptions(false);
      }
    };

    if (showDeleteModal) {
      fetchDeleteOptions();
    }
  }, [showDeleteModal]);

  useEffect(() => {
    const fetchDefaultWatchlist = async () => {
      try {
        const res = await getUserDefaultWatchlist();
        setUserDefaultWatchlistId(res.data.default_watchlist_id);
      } catch (error) {
        console.error("Failed to fetch default watchlist", error);
      }
    };

    fetchDefaultWatchlist();
  }, []);

  const handleSubmit = async (e) => {
    setLoader(true);
    const rawQuery = searchRef.current;
    let formattedQuery = rawQuery;
    if (category === "Forex") {
      if (!formattedQuery.startsWith("C:")) {
        formattedQuery = `C:${formattedQuery}`;
      }
    } else if (category === "Crypto") {
      if (!formattedQuery.startsWith("X:")) {
        formattedQuery = `X:${formattedQuery}`;
      }
    }
    const query = formattedQuery;

    const res = await searchStocksApi({
      search: query.toUpperCase() || "",
      category: category,
    });
    if (res && res?.data.status === 200) {
      setStockData(res?.data?.data);
      setLoader(false);
    } else {
      setLoader(false);
    }
  };

  const handleCategory = (cat) => {
    setCategory(cat);
  };

  const handleCategoryChange = async (newCategory) => {
    let parentTypeId = null;
    let defaultKey = null;

    if (newCategory === "Stocks") {
      parentTypeId = 1;
      defaultKey = "stocks";
    } else if (newCategory === "Forex") {
      parentTypeId = 2;
      defaultKey = "forex";
    } else if (newCategory === "Crypto") {
      parentTypeId = 3;
      defaultKey = "crypto";
    }

    try {
      if (defaultKey) {
        handleWatchlistClick(defaultKey);
      }
    } catch (err) {
      console.error("Error updating parent watchlists:", err);
    }
  };

  const handleDefaultWatchlistChange = async () => {
    if (String(userDefaultWatchlistId) === String(openWatchlistId)) {
      return;
    }

    try {
      setIsSettingDefault(true);

      const res = await setUserDefaultWatchlist({
        default_watchlist_id: openWatchlistId,
      });

      setUserDefaultWatchlistId(openWatchlistId);

      toast.success("Default watchlist set successfully ✅");
    } catch (error) {
      console.error("Failed to set default watchlist", error);

      toast.error(
        error?.response?.data?.message || "Failed to set default watchlist ❌",
      );
    } finally {
      setIsSettingDefault(false);
    }
  };

  const handleMobileDefaultWatchlist = async (watchlistId) => {
    const watchlistValue =
      watchlistId === 1
        ? "stocks"
        : watchlistId === 2
          ? "forex"
          : watchlistId === 3
            ? "crypto"
            : watchlistId;

    if (String(userDefaultWatchlistId) === String(watchlistValue)) {
      return;
    }

    try {
      setSettingWatchlistId(watchlistId);

      await setUserDefaultWatchlist({
        default_watchlist_id: watchlistValue,
      });

      setUserDefaultWatchlistId(watchlistValue);

      toast.success("Default watchlist set successfully");
    } catch (error) {
      console.error("Failed to set default watchlist", error);

      toast.error(
        error?.response?.data?.message || "Failed to set default watchlist ❌",
      );
    } finally {
      setSettingWatchlistId(null);
    }
  };

  const outletContext = useOutletContext();
  const sidebarToggle = Array.isArray(outletContext)
    ? outletContext[0]
    : outletContext?.sidebarToggle;
  const pathSegments = window.location.pathname.split("/");
  const colors = ["#35b23c", "#004c50", "#006565"];

  const Shell = embedded ? "div" : PageContainer;

  const canShowWatchlistGuide = !embedded && !isOldSearch;

  return (
    <>
      {canShowWatchlistGuide && guideIcon && !showWatchlistGuide && !isSidebarOpen && (
        <GuideLauncher onOpen={() => setShowWatchlistGuide(true)} />
      )}
      {canShowWatchlistGuide && showWatchlistGuide && (
        <WatchlistGuideSteps
          setShowGuide={setShowWatchlistGuide}
          onSelectList={(name) =>
            (isTabView ? watchlistMobileRef : watchlistDesktopRef).current?.selectListByName(name)
          }
        />
      )}

      {!embedded && (
        <>
          <DashboardHeader
            toggle={sidebarToggle}
            setStocksData={setStockData}
            setLoader={setLoader}
          />
          {window.location.pathname === "/auth/trending-stocks" ? (
            <PageHeaderTitle
              title={t("Today’s Movers")}
              showDesktopTitle={false}
            />
          ) : (
            <PageHeaderTitle title={t("WatchList")} showDesktopTitle={false} />
          )}
        </>
      )}
      <Shell>
        {window.location.pathname === "/auth/trending-stocks" && (
          <SettingsPageHeading
            title={t("Today’s Movers")}
            subtitle="Ranked by percent change. Moves often come from thinly traded, low-cap names. These are not QUSHi picks."
            className="md:hidden px-4 pt-4 mb-3"
          />
        )}
        {isMobileView &&
          isOldSearch &&
          window.location.pathname !== "/auth/trending-stocks" && (
            <TopbarSearch
              clearSearch={clearSearch}
              handleChange={handleChange}
              scButton={scButton}
              search={search}
              handleSubmit={handleSubmit}
              isMobileView={isMobileView}
              handleCategory={handleCategory}
            />
          )}
        <div
          className={`mt-1 mx-auto mb-24 w-full bg-white text-left ${
            window.location.pathname === "/auth/trending-stocks"
              ? "md:max-w-4xl md:rounded-2xl md:border md:border-gray-200"
              : "md:block rounded-2xl"
          }`}
        >
          <main>
            <div className="px-4">
              {pathSegments[1] === "auth" &&
              pathSegments[2] === "trending-stocks" ? (
                <>
                  <p className="hidden md:block font-sans text-sm font-normal leading-[18px] text-secondary pt-4">
                    Today’s biggest market moves, ranked by percent change.
                    Large moves often come from thinly traded, low-cap names.
                    These are not QUSHi picks.
                  </p>
                  <div className="hidden md:block border-t border-gray-300 w-full my-2" />
                  <div className="flex flex-col gap-4 w-full md:w-full mt-4">
                    {!loader && stocksData && stocksData.length > 0 ? (
                      stocksData.map((stock, index) => (
                        <Link
                          key={stock.stock_symbol}
                          to={`/chartSearch/${stock?.stock_symbol}`}
                          onClick={() =>
                            localStorage.setItem("ticker", stock?.stock_symbol)
                          }
                        >
                          <div className="flex flex-col w-full">
                            <div className="flex flex-row items-center justify-between gap-4">
                              <div className="text-xs md:text-[15px] w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                <div className="text-primaryColor font-bold">
                                  {stock?.stock_symbol}
                                </div>
                                <div className="text-ellipsis overflow-hidden text-gray-400">
                                  {stock && stock.stock_name ? (
                                    stock.stock_name
                                  ) : (
                                    <span style={{ opacity: 0 }}>N/A</span>
                                  )}
                                </div>
                              </div>
                              <div
                                className={`items-center text-xs md:text-[15px] w-full justify-center ${
                                  stock.percentageChange < 0
                                    ? "text-red-500"
                                    : "text-green-500"
                                }`}
                                style={{ maxWidth: "100px" }}
                              >
                                <div className="text-center font-medium overflow-hidden text-overflow-ellipsis whitespace-nowrap">
                                  $
                                  {stock?.latestData?.c
                                    .toFixed(2)
                                    .toLocaleString("en-US")}
                                </div>
                                <div className="text-center font-semibold">
                                  {stock.percentageChange < 0 ? "▼" : "▲"}
                                  {Math.abs(stock.percentageChange).toFixed(2)}%
                                </div>
                              </div>
                              <div className="text-right text-xs md:text-[15px] w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                <div className="text-primaryColor font-bold">
                                  ${stock?.total_trading_value}
                                </div>
                                <div className="text-gray-400">
                                  {stock.total_stock_value} shares
                                </div>
                              </div>
                            </div>

                            <div className="border-t border-gray-300 w-full my-2" />
                          </div>
                        </Link>
                      ))
                    ) : loader ? (
                      <ListSkeleton
                        rows={6}
                        avatarSize={40}
                        columns={1}
                        columnWidths={[80]}
                      />
                    ) : (
                      <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                        <p>No Data Found</p>
                      </div>
                    )}
                  </div>
                </>
              ) : !isOldSearch && !isTabView ? (
                <WatchlistDesktop ref={watchlistDesktopRef} />
              ) : !isOldSearch && isTabView ? (
                <div className="w-full pt-6 text-left md:pt-0">
                  <WatchlistMobile ref={watchlistMobileRef} />
                </div>
              ) : (
                <>
                  <div className="grid lg:grid-cols-[250px_1fr] grid-cols-1 gap-1 py-3">
                    <div>
                      {openParentId !== null && (
                        <>
                          {/* Back button — always visible */}
                          {![1, 2, 3].includes(openParentId) && (
                            <button
                              onClick={() => {
                                navigate("/search");
                              }}
                              className="svg_button inline-flex items-center gap-1 px-4 py-2  border border-primaryColor bg-primaryColor text-xl text-white hover:text-black hover:bg-transparent rounded-lg hover:border-black"
                            >
                              {IconLeftBold} Back
                            </button>
                          )}
                        </>
                      )}
                    </div>
                    {!isMobileView && (
                      <div className="flex gap-3 flex-wrap">
                        <button
                          onClick={() => setShowModal(true)}
                          className="inline-flex items-center bg-white gap-2 px-4 py-2 rounded-lg text-xl border border-black hover:border-primaryColor hover:bg-primaryColor transition-all duration-300 ease-in-out hover:text-white"
                        >
                          Create Watchlist
                        </button>
                        <button
                          onClick={() => setShowDeleteModal(true)}
                          className="inline-flex items-center bg-white gap-2 px-4 py-2 rounded-lg text-xl border border-black hover:border-primaryColor hover:bg-primaryColor transition-all duration-300 ease-in-out hover:text-white"
                        >
                          Delete Watchlist
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="grid lg:grid-cols-[250px_1fr] grid-cols-1 gap-1 pb-7">
                    <div className="lg:bg-[#f1f5f9] lg:p-4 rounded-lg xl:min-h-screen">
                      <ul className="space-y-3">
                        {openParentId === null &&
                          parentWatchlists.map((wl) => (
                            <li
                              key={wl.id}
                              style={{ backgroundColor: getColorForId(wl.id) }}
                              className="relative flex items-center justify-center cursor-pointer outline-offset-2 outline md:rounded rounded-lg px-4 xl:h-[110px] h-[90px] max-md:border-2 border-black text-center text-2xl font-bold text-white transition-all duration-300 ease-in-out"
                              onClick={() => {
                                localStorage.removeItem("watchlistName");
                                if (isTabView) {
                                  navigate(`/mobile-watchlist/${wl.id}`, {
                                    state: {
                                      name: wl.name,
                                      isSystemWatchlist: wl.is_system,
                                      fromChart1: fromChart1,
                                    },
                                  });
                                } else {
                                  setSearchResults([]);
                                  setOpenParentId(wl.id);
                                  handleParentClick(wl.id);
                                }
                              }}
                            >
                              {isMobileView &&
                                allowedDefaultIds.includes(wl.id) && (
                                  <div
                                    className="absolute top-2 right-2 z-10"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <input
                                      type="checkbox"
                                      style={{ accentColor: "#004C50" }}
                                      checked={
                                        String(userDefaultWatchlistId) ===
                                        String(
                                          wl.id === 1
                                            ? "stocks"
                                            : wl.id === 2
                                              ? "forex"
                                              : wl.id === 3
                                                ? "crypto"
                                                : wl.id,
                                        )
                                      }
                                      disabled={settingWatchlistId === wl.id}
                                      onChange={() =>
                                        handleMobileDefaultWatchlist(wl.id)
                                      }
                                    />

                                    {settingWatchlistId === wl.id && (
                                      <span className="ml-1 text-xs">...</span>
                                    )}
                                  </div>
                                )}

                              <div>
                                {wl.name === "Qushi Watchlist" ? (
                                  <img
                                    className="object-contain mx-auto md:h-[42px] h-[20px]"
                                    src={require("./../images/wachlist.png")}
                                    alt="Qushi Watchlist"
                                  />
                                ) : (
                                  wl.name
                                )}
                              </div>
                            </li>
                          ))}

                        {openParentId !== null && (
                          <>
                            {childWatchlists.filter(
                              (child) => child.parent_id === openParentId,
                            ).length > 0
                              ? childWatchlists
                                  .filter(
                                    (child) => child.parent_id === openParentId,
                                  )
                                  .map((wl) => (
                                    <div key={wl.id}>
                                      <li
                                        style={{
                                          backgroundColor: getColorForId(wl.id),
                                        }}
                                        className="relative cursor-pointer outline-offset-2 outline rounded px-4 xl:py-10 py-5 text-center text-xl font-bold text-white transition-all duration-300 ease-in-out"
                                        onClick={() => {
                                          localStorage.removeItem(
                                            "watchlistName",
                                          );
                                          setSearchResults([]);
                                          handleWatchlistClick(wl.id);
                                          setOpenWatchlistName(wl.name);
                                          setDeleteMode(false);
                                          setSelectedItems([]);
                                        }}
                                      >
                                        <div>{wl.name}</div>
                                      </li>
                                    </div>
                                  ))
                              : [1, 2, 3].includes(openParentId) &&
                                parentWatchlists.map((wl) => (
                                  <li
                                    key={wl.id}
                                    style={{
                                      backgroundColor: getColorForId(wl.id),
                                    }}
                                    className="relative cursor-pointer outline-offset-2 outline rounded px-4 xl:py-10 py-5 text-center text-xl font-bold text-white transition-all duration-300 ease-in-out"
                                    onClick={() => {
                                      localStorage.removeItem("watchlistName");
                                      setOpenParentId(wl.id);
                                      handleParentClick(wl.id);
                                    }}
                                  >
                                    <div>{wl.name}</div>
                                  </li>
                                ))}
                          </>
                        )}
                      </ul>
                    </div>
                    {!isMobileView && (
                      <div className="bg-[#f1f5f9] p-4 rounded-lg">
                        {["stocks", "forex", "crypto"].includes(
                          String(openWatchlistId)?.toLowerCase(),
                        ) && (
                          <SearchBar
                            onResults={setSearchResults}
                            onCategoryChange={handleCategoryChange}
                            openWatchlistId={openWatchlistId}
                          />
                        )}

                        {searchResults.length > 0 && (
                          <div className="space-y-2">
                            {searchResults.map((item, i) => (
                              <div
                                key={i}
                                className="p-2 border rounded bg-white shadow flex items-center justify-between"
                              >
                                <div class="flex flex-row items-center justify-between w-full gap-4 max-md:flex-wrap">
                                  <div class="grid grid-cols-[auto_1fr] gap-5 items-center text-base w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                    <div class="mx-auto max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] md:text-[16px] text-[10px] text-center text-white-A700 w-[83px] bg-primaryColor">
                                      <span class="text-white max-sm:break-all leading-normal text-[13.5px]">
                                        {baseSymbol(
                                          item.ticker,
                                          category?.toLowerCase(),
                                        )}
                                      </span>
                                    </div>
                                    <div>
                                      <div class="text-lg text-black whitespace-normal font-montserrat">
                                        {instrumentName({
                                          name: item.name,
                                          symbol: item.ticker,
                                          category: category?.toLowerCase(),
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="text-right w-auto text-base md:w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                    <div class="text-primaryColor font-bold">
                                      <button
                                        onClick={() => {
                                          setSelectedItem(item);
                                          setShowAddModal(true);
                                        }}
                                        className="px-3 py-1 grayscale hover:grayscale-0"
                                      >
                                        {IconPlusCircle}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <h1 style={{ margin: 0 }}>Default Watchlist</h1>

                          <input
                            type="checkbox"
                            style={{ accentColor: "#004C50" }}
                            checked={
                              String(userDefaultWatchlistId) ===
                              String(openWatchlistId)
                            }
                            onChange={handleDefaultWatchlistChange}
                            disabled={isSettingDefault}
                          />

                          {isSettingDefault && <span>Setting...</span>}
                        </div>

                        {openWatchlistId && searchResults.length === 0 && (
                          <div>
                            <div className="flex justify-between items-center mb-2">
                              <h2 className="text-xl font-bold ">
                                {![1, 2, 3, null, undefined].includes(
                                  openParentId,
                                ) &&
                                  (openWatchlistName ||
                                    localStorage.getItem("watchlistName")) && (
                                    <>
                                      {openWatchlistName ||
                                        localStorage.getItem("watchlistName")}
                                    </>
                                  )}
                              </h2>
                              {openParentId === 4 && (
                                <button
                                  onClick={() => setShowOptionsModal(true)}
                                  className="px-3 py-1.5  text-gray-700 rounded hover:bg-gray-100 transition"
                                >
                                  <img src={pencilIcon} width={18} />
                                </button>
                              )}
                            </div>
                            {initialLoading ? (
                              <ListSkeleton
                                rows={6}
                                avatarSize={36}
                                columns={2}
                                columnWidths={[70, 56]}
                                rowClassName="py-3.5"
                              />
                            ) : selectedWatchlist.length === 0 ? (
                              <div className="text-center p-10">
                                <p>No items available</p>
                              </div>
                            ) : (
                              <div className="space-y-2" ref={containerRef}>
                                {!isSystemWatchlist
                                  ? selectedWatchlist.map((item) => (
                                      <div
                                        key={item.id}
                                        className="relative flex items-center"
                                      >
                                        {deleteMode && (
                                          <span
                                            className="mr-2 cursor-pointer"
                                            onClick={async (e) => {
                                              e.stopPropagation();
                                              try {
                                                await deleteWatchlistItem(
                                                  item.id,
                                                );
                                                setSelectedWatchlist((prev) =>
                                                  prev.filter(
                                                    (it) => it.id !== item.id,
                                                  ),
                                                );
                                                toast.success(
                                                  "Item deleted successfully!",
                                                );
                                                setDeleteMode(false);
                                                setSelectedItems([]);
                                              } catch (err) {
                                                console.error(err);
                                                toast.error(
                                                  "Failed to delete item.",
                                                );
                                              }
                                            }}
                                          >
                                            <img
                                              width={25}
                                              src={deleteIcon}
                                              alt="delete"
                                            />
                                          </span>
                                        )}

                                        <Link
                                          to={`/chartSearch/${
                                            item.is_system && item.etf
                                              ? item.etf
                                              : item.symbol
                                          }`}
                                          onClick={() => {
                                            localStorage.setItem(
                                              "lastWatchlistId",
                                              openWatchlistId,
                                            );
                                            localStorage.setItem(
                                              "lastParentId",
                                              openParentId,
                                            );
                                            localStorage.setItem(
                                              "uselastWatchlistId",
                                              openWatchlistId,
                                            );
                                            localStorage.setItem(
                                              "watchlistName",
                                              openWatchlistName,
                                            );
                                            const tickerSymbol =
                                              item.is_system && item.etf
                                                ? item.etf
                                                : item.symbol;
                                            localStorage.setItem(
                                              "ticker",
                                              tickerSymbol,
                                            );
                                          }}
                                          className="bg-white block p-4 rounded hover:bg-primaryColor/10 flex-1"
                                        >
                                          <div className="flex flex-col w-full">
                                            <div className="flex flex-row items-center justify-between gap-4 max-md:flex-wrap">
                                              <div className="grid grid-cols-[auto_1fr] gap-5 items-center text-base w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                                {[
                                                  1,
                                                  2,
                                                  3,
                                                  null,
                                                  undefined,
                                                ].includes(openParentId) ? (
                                                  <img
                                                    className="h-20 w-20 object-contain"
                                                    height={83}
                                                    width={83}
                                                    src={
                                                      item?.logo ||
                                                      "/bitcoin.png"
                                                    }
                                                    alt="logo"
                                                  />
                                                ) : (
                                                  <div className="mx-auto max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] md:text-[16px] text-[10px] text-center text-white-A700 w-[83px] bg-primaryColor">
                                                    <span className="text-white max-sm:break-all leading-normal text-[13.5px]">
                                                      {item.watchlist_name}
                                                    </span>
                                                  </div>
                                                )}

                                                <div>
                                                  <div className="text-lg text-black whitespace-normal font-montserrat">
                                                    {item.details.stock_name
                                                      ? item.details.stock_name
                                                      : "N/A"}
                                                  </div>
                                                </div>
                                              </div>
                                              {![
                                                1,
                                                2,
                                                3,
                                                null,
                                                undefined,
                                              ].includes(openParentId) ? (
                                                <>
                                                  <div
                                                    className={`items-center text-base w-full justify-center ${
                                                      item.details
                                                        .percentageChange < 0
                                                        ? "text-red-500"
                                                        : "text-green-500"
                                                    }`}
                                                    style={{
                                                      maxWidth: "100px",
                                                    }}
                                                  >
                                                    <div
                                                      className="md:text-center font-semibold overflow-hidden text-overflow-ellipsis whitespace-nowrap w-full justify-center"
                                                      style={{
                                                        maxWidth: "100px",
                                                      }}
                                                    >
                                                      $
                                                      {Number(
                                                        item?.details
                                                          ?.latestData?.c,
                                                      ).toLocaleString(
                                                        "en-US",
                                                        {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                        },
                                                      )}
                                                    </div>
                                                    <div className="md:text-center text-base">
                                                      {item.details
                                                        .percentageChange < 0
                                                        ? "▼"
                                                        : "▲"}
                                                      {Math.abs(
                                                        item.details
                                                          .percentageChange,
                                                      ).toFixed(2)}
                                                      %
                                                    </div>
                                                  </div>

                                                  <div className="text-right w-auto text-base md:w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                                    <div className="text-primaryColor font-bold">
                                                      {
                                                        item?.details
                                                          .total_trading_value
                                                      }
                                                    </div>
                                                    <div className="text-gray-400">
                                                      {
                                                        item?.details
                                                          .total_stock_value
                                                      }{" "}
                                                      shares
                                                    </div>
                                                  </div>
                                                </>
                                              ) : (
                                                <button
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setSelectedItem(item);
                                                    setShowAddModal(true);
                                                  }}
                                                  className="px-3 py-1 grayscale hover:grayscale-0"
                                                >
                                                  {IconPlusCircle}
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </Link>
                                      </div>
                                    ))
                                  : selectedWatchlist.map((item) => (
                                      <Link
                                        key={item.id}
                                        to={`/chartSearch/${
                                          item.is_system && item.etf
                                            ? item.etf
                                            : item.symbol
                                        }`}
                                        onClick={() => {
                                          localStorage.setItem(
                                            "lastWatchlistId",
                                            openWatchlistId,
                                          );
                                          localStorage.setItem(
                                            "lastParentId",
                                            openParentId,
                                          );
                                          localStorage.setItem(
                                            "uselastWatchlistId",
                                            openWatchlistId,
                                          );
                                          localStorage.setItem(
                                            "watchlistName",
                                            openWatchlistName,
                                          );
                                          const tickerSymbol =
                                            item.is_system && item.etf
                                              ? item.etf
                                              : item.symbol;
                                          localStorage.setItem(
                                            "ticker",
                                            tickerSymbol,
                                          );
                                        }}
                                      >
                                        <div
                                          key={item.id}
                                          className="rounded bg-[#fff] grid grid-cols-[auto_1fr_auto] gap-3 p-4 hover:bg-primaryColor/10 items-center"
                                        >
                                          <div>
                                            <img
                                              className="h-20 w-20 object-contain"
                                              height={83}
                                              width={83}
                                              src={item?.logo || "/bitcoin.png"}
                                              alt="logo"
                                            />
                                          </div>
                                          <div>
                                            <h3 className="font-bold text-3xl">
                                              {item?.watchlist_name || "N/A"}
                                            </h3>
                                            <p>
                                              {item?.description ||
                                                "No description available"}
                                            </p>
                                          </div>
                                          <div className="text-base">
                                            <h4>
                                              $
                                              {Number(
                                                item?.details?.latestData?.c,
                                              ).toLocaleString("en-US", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </h4>
                                            <p
                                              className={`flex items-center gap-1 font-bold ${
                                                item.details.percentageChange <
                                                0
                                                  ? "text-red-500"
                                                  : "text-green-500"
                                              }`}
                                            >
                                              <img
                                                src={
                                                  item.details
                                                    .percentageChange < 0
                                                    ? "/red-down.png"
                                                    : "/green-up.png"
                                                }
                                                width={16}
                                                alt="trend"
                                              />
                                              {Math.abs(
                                                item.details.percentageChange,
                                              ).toFixed(2)}
                                              %
                                            </p>
                                          </div>
                                        </div>
                                      </Link>
                                    ))}

                                <div
                                  ref={loaderRef}
                                  className="flex justify-center p-4"
                                >
                                  {loadingMore && (
                                    <p className="text-gray-400">
                                      Loading more...
                                    </p>
                                  )}
                                  {!hasMore && (
                                    <p className="text-gray-400">
                                      No more items
                                    </p>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {showAddModal && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white p-6 rounded-lg shadow-lg w-80 text-center">
                        <h3 className="text-lg font-semibold mb-4">Add</h3>

                        <p className="mb-4 text-gray-700">
                          {selectedItem
                            ? `${selectedItem.ticker || selectedItem.details.stock_symbol} (${selectedItem.name || selectedItem.details.stock_name})`
                            : ""}
                        </p>

                        {loadingOptions ? (
                          <p className="text-gray-500 mb-4">
                            Loading options...
                          </p>
                        ) : (
                          <div className="space-y-3 mb-4 text-left">
                            {addOptions.length > 0 ? (
                              addOptions.map((option) => (
                                <div
                                  key={option.id}
                                  onClick={async () => {
                                    if (!selectedItem) return;
                                    try {
                                      const res = await addStockToWatchlists(
                                        selectedItem.ticker ||
                                          selectedItem.details.stock_symbol,
                                        [option.id],
                                      );
                                      if (res.status === 200) {
                                        toast.success(
                                          `Added to "${option.name}" successfully!`,
                                        );
                                        setShowAddModal(false);
                                        setSelectedWatchlists([]);
                                      } else {
                                        toast.error("Failed to add stock.");
                                      }
                                    } catch (err) {
                                      console.error(err);
                                      toast.error("Error adding stock.");
                                    }
                                  }}
                                  style={{
                                    backgroundColor: getColorForId(option.id),
                                  }}
                                  className="cursor-pointer border rounded-lg px-3 py-3 text-white text-center transition"
                                >
                                  {option.name}
                                </div>
                              ))
                            ) : (
                              <p className="text-gray-500">
                                No watchlists found.
                              </p>
                            )}
                          </div>
                        )}

                        <div className="flex justify-center">
                          <button
                            onClick={() => {
                              setShowAddModal(false);
                              setSelectedWatchlists([]);
                            }}
                            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {showDeleteModal && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white p-6 rounded-lg shadow-lg w-80 text-center">
                        <h3 className="text-lg font-semibold mb-4">
                          Delete Watchlist
                        </h3>

                        {loadingDeleteOptions ? (
                          <p className="text-gray-500 mb-4">
                            Loading watchlists...
                          </p>
                        ) : (
                          <div className="space-y-3 mb-4 text-left">
                            {deleteOptions.length > 0 ? (
                              deleteOptions.map((option) => (
                                <div
                                  key={option.id}
                                  onClick={async () => {
                                    try {
                                      const res = await deleteWatchlists([
                                        option.id,
                                      ]);
                                      if (res.status === 200) {
                                        toast.success(
                                          `"${option.name}" deleted successfully!`,
                                        );
                                        setShowDeleteModal(false);
                                        setSelectedDeleteWatchlists([]);
                                      } else {
                                        toast.error(
                                          "Failed to delete watchlist.",
                                        );
                                      }
                                    } catch (err) {
                                      console.error(err);
                                      toast.error("Error deleting watchlist.");
                                    }
                                  }}
                                  style={{
                                    backgroundColor: getColorForId(option.id),
                                  }}
                                  className="cursor-pointer border rounded-lg px-3 py-3 text-white text-center transition"
                                >
                                  {option.name}
                                </div>
                              ))
                            ) : (
                              <p className="text-gray-500">
                                No watchlists available.
                              </p>
                            )}
                          </div>
                        )}

                        <div className="flex justify-center">
                          <button
                            onClick={() => {
                              setShowDeleteModal(false);
                              setSelectedDeleteWatchlists([]);
                            }}
                            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {showModal && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
                      <div className="bg-white rounded p-6 w-96">
                        <h3 className="text-lg font-bold mb-4">
                          Create Watchlist
                        </h3>

                        <input
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          placeholder="Enter watchlist name"
                          className="w-full border px-3 py-2 mb-4 rounded"
                        />

                        <div className="flex justify-end space-x-2">
                          <button
                            onClick={() => setShowModal(false)}
                            className="px-4 py-2 border rounded"
                            disabled={loading}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleCreate}
                            className="px-4 py-2 bg-primaryColor text-white rounded"
                            disabled={loading}
                          >
                            {loading ? "Creating..." : "Create"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {showOptionsModal && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white p-6 rounded-lg shadow-lg w-80 text-center">
                        <div className="space-y-3 text-center">
                          <button
                            onClick={() => {
                              setShowOptionsModal(false);
                              setShowAddInstrumentModal(true);
                            }}
                            className="block w-full text-center bg-[#f8f9f9] gap-2 px-4 py-3 rounded"
                          >
                            Add Instrument
                          </button>

                          <button
                            onClick={() => {
                              setShowOptionsModal(false);
                              setDeleteMode(true);
                            }}
                            className="block w-full text-center bg-[#f8f9f9] gap-2 px-4 py-3 rounded"
                          >
                            Delete
                          </button>
                          <button
                            onClick={() => setShowOptionsModal(false)}
                            className="block w-full text-center bg-[#f8f9f9] gap-2 px-4 py-3 rounded"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {showAddInstrumentModal && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                      <div className="bg-white p-6 rounded-lg shadow-lg w-80 text-center">
                        <h3 className="text-lg font-semibold mb-4">
                          Select Instrument Type
                        </h3>

                        <div className="grid gap-3">
                          <button
                            onClick={() => {
                              setOpenParentId(1);
                              handleParentClick(1);
                              setShowAddInstrumentModal(false);
                            }}
                            className="w-full px-4 py-3 text-white hover:bg-[#35b23c]]/70 bg-[#35b23c] rounded-lg"
                          >
                            Stocks
                          </button>

                          <button
                            onClick={() => {
                              setOpenParentId(2);
                              handleParentClick(2);
                              setShowAddInstrumentModal(false);
                            }}
                            className="w-full px-4 py-3 text-white hover:bg-primaryColor/70 bg-primaryColor rounded-lg"
                          >
                            Forex
                          </button>

                          <button
                            onClick={() => {
                              setOpenParentId(3);
                              handleParentClick(3);
                              setShowAddInstrumentModal(false);
                            }}
                            className="w-full px-4 py-3 text-white hover:bg-[#006565]/70 bg-[#006565] rounded-lg"
                          >
                            Crypto
                          </button>
                        </div>

                        <button
                          onClick={() => setShowAddInstrumentModal(false)}
                          className="mt-4 text-gray-500 hover:underline"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </main>
        </div>
      </Shell>
    </>
  );
};

export default SearchPage;
